import { useQuery } from '@tanstack/react-query';
import { isApiError } from '@/shared/lib/apiClient';
import {
  SUBSCRIPTION_EVENT_QUERY_KEYS,
  SUBSCRIPTION_EVENT_REFETCH_INTERVAL_MS,
} from '../constants';
import { fetchSubscriptionEventAnalytics } from '../services/subscriptionEvents.api';

export function useSubscriptionEventAnalytics(enabled: boolean) {
  return useQuery({
    queryKey: SUBSCRIPTION_EVENT_QUERY_KEYS.analytics,
    queryFn: ({ signal }) => fetchSubscriptionEventAnalytics(signal),
    enabled,
    staleTime: 15_000,
    refetchInterval: enabled ? SUBSCRIPTION_EVENT_REFETCH_INTERVAL_MS : false,
    refetchIntervalInBackground: false,
    retry: (failureCount, error) => {
      if (isApiError(error) && (error.status === 401 || error.status === 403)) {
        return false;
      }
      return failureCount < 1;
    },
  });
}
